<template>
  <div class="animated fadeIn pt2 pb4">
    <div class="clearfix gibson px2 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 shadow">
          <div class="col-12 px2">
            <p class="h4 gibson darkblue semi-bold line-height-2 my2">Brug dine tilfredse kunder - til at tiltrække nye</p>
            <p class="h5 regular darkblue line-height-golden gibson">
              Klik ind her og se hvordan du let kan få reklame på din varevogn og lave dit eget personlige visitkort med dine anbefalinger på.
            </p>
            <button v-if="showimentor" target="_blank" :href="`http://www.kundematch.dk/newpartner/BrandCentral.php?id=${salesPerson}`" class="col-12 primary-button p2 flex justify-center items-center not-rounded border-none my3">
              <span class="gibson regular h5 mb0">Streamers og visitkort</span>
            </button>
            <p class="h5 regular darkblue line-height-golden gibson">
              Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på <a href="tel:+4570228014" class="">70 22 80 14</a> eller skriv til <a href="mailto:info@haandvaerker.dk" class="">info@haandvaerker.dk</a>.
            </p>
            <p class="h5 regular darkblue line-height-golden gibson">
              Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige møder. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på <a href="tel:+4570228014" class="">70 22 80 14</a>.
            </p>
          </div>
          <haandvaerker></haandvaerker>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Haandvaerker from './haandvaerker'
export default {
  name: 'kreditkort',
  components: {
    Haandvaerker
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      haaCredit: false,
      showimentor: true,
      showDismissibleAlert: false
    }
  },
  created () {
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true
    }
    if (localStorage.getItem('haaid') === '0') {
      this.showimentor = false
    }
    this.salesPerson = localStorage.getItem('id_token_portal')
    var data = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no'}
    this.$http.post('', data, { emulateJSON: true })
      .then(
        response => {
          var res = response.body
          if (res.login === false) {
            this.$router.push('/login')
          }
          this.haaCredit = res.haacredit
        },
        response => {
          alert('error')
        }
      )
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// EditvisitKort.vue?552d4328